import { Component, HostListener, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-recognition',
  templateUrl: './recognition.component.html',
  styleUrls: ['./recognition.component.css']
})
export class RecognitionComponent implements OnInit {

  @Input() data: Array<any>
  @Input() round: number
  @Input() started: boolean
  @Input() startFunction: Function
  @Input() submitTask: Function
  @Input() timestamp: Function
  @Input() checkRound: Function
  @Input() currentAnswers: any[]
  @Input() block: number
  @Input() recognitionTask: string
  @Input() overview: boolean
  @Input() computePercentage: Function

  constructor(public translate: TranslateService) { }

  ngOnInit(): void {
  }

  vote(val: string) {

    //check if word already in array
    const wordIndex = this.currentAnswers.findIndex((word) => word.id === this.data[this.block][this.round].id)
    if (wordIndex !== -1) {
      //word already in currentAnswers --> update object at position wordIndex
      if (this.recognitionTask === 'oldNew') {
        this.currentAnswers[wordIndex].timestampOldNew = this.timestamp()
        this.currentAnswers[wordIndex].choiceOldNew = parseInt(val)
      }
      else {
        this.currentAnswers[wordIndex].timestampSource = this.timestamp()
        this.currentAnswers[wordIndex].choiceSource = parseInt(val)
      }
    }

    else {
      //word not in currentAnswers --> push new object
      if (this.recognitionTask === 'oldNew')
        this.currentAnswers.push({
          id: this.data[this.block][this.round].id,
          timestampOldNew: this.timestamp(),
          choiceOldNew: parseInt(val)
        })
      else
        this.currentAnswers.push({
          id: this.data[this.block][this.round].id,
          timestampSource: this.timestamp(),
          choiceSource: parseInt(val)
        })

    }
    //console.log("sono qui: ");
    //console.log(this.currentAnswers)
    this.checkRound('recognition', parseInt(val))
  }

  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (this.started) {
      const key = event.key

      if ((key === "1" || key == "2" || key == "3" || key == "4" || key == "5")) {
        this.vote(key)
      }
    }
  }


  formatBlockNumber = (blockNum: number) => {
    switch (blockNum) {
      case 1:
        return 'st'
      case 2:
        return 'nd'
      case 3:
        return 'rd'
      case 4:
        return 'th'
    }
  }

}
